import React from 'react';
import { useSelector } from 'react-redux';
import { Page } from 'src/features/layout/Page';
import { getProposedMovements, getUnassignedMovements } from '../store/movementSelectors';
import './movements.scss';
import { ClaimAllMovements } from './ClaimAllMovements';
import { ClaimMovement } from './ClaimMovement';
import { AssignmentStatus, EldMovement, ProposedTrip } from 'src/common/types';
import { isMobile } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { Button } from 'src/components/Button';
import ArrowIcon from 'src/assets/layout/navigation/arrow.svg';
import { ProposedMovement } from './ProposedMovement';
import { AcceptAllAssigned } from './AcceptAllAssigned';
import { format } from 'date-fns';

export const Movements: React.FC = () => {
  const unassignedMovements = useSelector(getUnassignedMovements) as EldMovement[];
  const proposedTrips = useSelector(getProposedMovements) as ProposedTrip[];

  const groupMovementsByDay = (movements: EldMovement[]) => {
    return movements
      .filter(movement => movement.endTimestamp)
      .reduce((acc, movement) => {
        const day = format(new Date(movement.startTimestamp), 'yyyy-MM-dd');
        if (!acc[day]) {
          acc[day] = [];
        }
        acc[day].push(movement);
        return acc;
      }, {} as { [key: string]: EldMovement[] });
  };

  const groupedMovements = groupMovementsByDay(unassignedMovements);
  const groupedProposed = proposedTrips
    .filter(movement => movement.movementAssignment.startTimestamp)
    .reduce((acc, movement) => {
      const day = format(new Date(movement.movementAssignment.startTimestamp), 'yyyy-MM-dd');
      if (!acc[day]) {
        acc[day] = [];
      }
      acc[day].push(movement);
      return acc;
    }, {} as { [key: string]: ProposedTrip[] });

  return (
    <Page>
      {isMobile && (
        <Link to="/hos-logs">
          <Button title="Back" icon={ArrowIcon} className="movements-button-back" />
        </Link>
      )}
      <div className="movements-page">
        {proposedTrips.length > 0 && (
          <>
            <div className="movements-header">
              <div className="movements-title">Proposed Trips</div>
            </div>
            {Object.keys(groupedProposed).map(day => (
              <>
                <AcceptAllAssigned key={day} movements={groupedProposed[day]} day={day} />
                <div className="movements-claims">
                  {groupedProposed[day].map(movement => (
                    <ProposedMovement
                      key={movement.movementId}
                      movement={movement as ProposedTrip}
                    />
                  ))}
                </div>
              </>
            ))}
          </>
        )}
        <div className="movements-header">
          <div className="movements-title">Claim unassigned trips</div>
        </div>
        {Object.keys(groupedMovements).map(day => (
          <div key={day} className="movements-day-group">
            {groupedMovements[day].length > 0 && (
              <>
                <ClaimAllMovements movements={groupedMovements[day]} day={day} />
                <div className="movements-claims">
                  {groupedMovements[day].map(movement => (
                    <ClaimMovement
                      key={movement.movementId}
                      movement={movement as EldMovement}
                      type={AssignmentStatus.UNASSIGNED}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </Page>
  );
};
